/* SS - «Vis produkter»: åpne og lukke produktboksen (snippets/ss-shop-pill.liquid).
   Kristoffer/Claude 22.09.2026.
   Legg-i-kurv er IKKE her: assets/ss-family.js lytter på document etter .ss-fam__add, så både
   radene og kortene virker derfra - med størrelsesvalidering, rød ramme ved manglende størrelse
   og gOpenCart. Denne fila gjør bare åpne/lukke.
   Én pille og to bokser deler samme uid: desktop-boksen ([data-ss-shop-box]) ligger i kortet,
   mobilarket ([data-ss-shop-sheet]) utenfor sporet. CSS avgjør hvilken som vises. */
(function () {
  /* 22.09.2026: begge seksjonene skriver ut <script src=ss-shop.js>, og to like script-tagger
     kjores BEGGE. Uten denne vakten bindes klikk-lytteren dobbelt: forste apner boksen, andre
     ser at aria-expanded na er true og lukker den igjen - pillen virket ikke i det hele tatt. */
  if (window.__ssShopInit) return;
  window.__ssShopInit = true;

  var OPEN = 'is-open';

  function boxes(uid) {
    return [].slice.call(document.querySelectorAll(
      '[data-ss-shop-box="' + uid + '"],[data-ss-shop-sheet="' + uid + '"],[data-ss-shop-backdrop="' + uid + '"]'));
  }
  function pills(uid) {
    return [].slice.call(document.querySelectorAll('[data-ss-shop="' + uid + '"]'));
  }
  function closeAll(except) {
    var open = document.querySelectorAll('[data-ss-shop-box].' + OPEN + ',[data-ss-shop-sheet].' + OPEN);
    for (var i = 0; i < open.length; i++) {
      var uid = open[i].getAttribute('data-ss-shop-box') || open[i].getAttribute('data-ss-shop-sheet');
      if (uid !== except) set(uid, false);
    }
  }
  function set(uid, on) {
    boxes(uid).forEach(function (el) { el.classList.toggle(OPEN, on); });
    pills(uid).forEach(function (el) { el.setAttribute('aria-expanded', String(on)); });
    /* mobil: lås siden bak arket, og la den gule sticky-knappen vike (ss-sticky-atc.css) */
    var anyOpen = !!document.querySelector('[data-ss-shop-sheet].' + OPEN);
    document.body.classList.toggle('ss-shop-open', anyOpen);
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-ss-shop]');
    if (pill) {
      var uid = pill.getAttribute('data-ss-shop');
      var cur = document.querySelector('[data-ss-shop-box="' + uid + '"].' + OPEN +
                                       ',[data-ss-shop-sheet="' + uid + '"].' + OPEN);
      var on = !cur;
      closeAll(on ? uid : null);
      set(uid, on);
      return;
    }
    var x = e.target.closest('[data-ss-shop-close]');
    if (x) {
      var host = x.closest('[data-ss-shop-box],[data-ss-shop-sheet]');
      if (host) set(host.getAttribute('data-ss-shop-box') || host.getAttribute('data-ss-shop-sheet'), false);
      return;
    }
    var bd = e.target.closest('[data-ss-shop-backdrop]');
    if (bd) { set(bd.getAttribute('data-ss-shop-backdrop'), false); return; }
    /* Klikk utenfor lukker. Arket MA telles som «innenfor» ogsa: pa mobil ligger
       storrelsesvelgeren i arket, ikke i boksen, sa uten det lukket et trykk pa
       storrelsen hele arket (Kristoffer 22.09). */
    if (!e.target.closest('[data-ss-shop-box],[data-ss-shop-sheet],[data-ss-shop]')) closeAll(null);
  });

  /* radenes storrelsesvelger: ss-family.js returnerer tidlig for den (den har ingen
     .ss-fam__sizewrap), sa is-missing ville aldri blitt fjernet igjen, og teksten aldri sort. */
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.classList || !s.classList.contains('ss-fam__size')) return;
    if (!s.closest('.ss-shop__rbuy')) return;
    s.classList.remove('is-missing');
    s.classList.toggle('is-set', !!s.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* cart-draweren tar over etter «Legg til» (ss-family.js sender gOpenCart) */
  document.addEventListener('gOpenCart', function () { closeAll(null); });

  /* karusellen: sveiper man videre, hopper settle() fra en klone til originalen og boksen ville
     sett ut som den forsvant. Lukk den heller med en gang. */
  function watchTracks(scope) {
    var tracks = (scope || document).querySelectorAll('.ss-proof__track');
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i].__ssShop) continue;
      tracks[i].__ssShop = true;
      tracks[i].addEventListener('scroll', function () { closeAll(null); }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchTracks(); });
  else watchTracks();
  document.addEventListener('shopify:section:load', function (e) { watchTracks(e.target); });
})();
